import { LinkActivationType } from '#pplx/frontend/composer-sdk/link.js';
import { AutoLinkNode, LinkNode } from '@lexical/link';
/**
 * Lexical node classes required by any surface declaring `LinkCapability`.
 * Registered automatically by `<Composer />` when a plugin declares the
 * capability — never wire these directly on a consumer's `initialConfig`.
 */
export const LINK_CAPABILITY_NODES = [LinkNode, AutoLinkNode];
//# sourceMappingURL=cap-link.js.map